var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3431",
    "data-name": "Group 3431",
    xmlns: "http://www.w3.org/2000/svg",
    width: 209.672,
    height: 63.763,
    viewBox: "0 0 209.672 63.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3401",
    "data-name": "Group 3401",
    transform: "translate(11.745 10.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394",
    transform: "translate(24.148 15.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4797",
    "data-name": "Path 4797",
    d: "M2445.76,677.584l-7.989-4.61-6.57,6.351,6,5.8,8.554-4.938a1.506,1.506,0,0,0,0-2.608Z",
    transform: "translate(-2431.202 -672.974)",
    fill: "#ffd109"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396",
    transform: "translate(1.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4798",
    "data-name": "Path 4798",
    d: "M2295.243,574.972l-8.791-5.074-19.265-9.873,21.76,21.034Z",
    transform: "translate(-2267.186 -560.025)",
    fill: "#06ef79"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(1.626 23.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3397",
    "data-name": "Group 3397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4799",
    "data-name": "Path 4799",
    d: "M2269.482,746.82l18.979-10.455,8.192-4.729-5.731-5.541Z",
    transform: "translate(-2269.482 -726.095)",
    fill: "#f93646"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400",
    transform: "translate(0 0.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3399",
    "data-name": "Group 3399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4800",
    "data-name": "Path 4800",
    d: "M2257.828,566.136l-.021,42.48,21.983-21.25Z",
    transform: "translate(-2257.808 -566.136)",
    fill: "#05d5fb"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3429",
    "data-name": "Group 3429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3415",
    "data-name": "Group 3415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3414",
    "data-name": "Group 3414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4825",
    "data-name": "Path 4825",
    d: "M2375.043,484.391a6.719,6.719,0,0,1,6.712,6.712v47.553a6.72,6.72,0,0,1-6.712,6.712H2181.581a6.72,6.72,0,0,1-6.712-6.712V491.1a6.719,6.719,0,0,1,6.712-6.712h193.462m0-1.393H2181.581a8.1,8.1,0,0,0-8.1,8.1v47.553a8.1,8.1,0,0,0,8.1,8.1h193.462a8.1,8.1,0,0,0,8.1-8.1V491.1a8.1,8.1,0,0,0-8.1-8.1Z",
    transform: "translate(-2173.476 -482.998)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3427",
    "data-name": "Group 3427",
    transform: "translate(56.162 29.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416",
    transform: "translate(0 0.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4826",
    "data-name": "Path 4826",
    d: "M2589.3,707.843h2.924v6.633a9.293,9.293,0,0,1-3,1.569,11.5,11.5,0,0,1-3.519.547,9.488,9.488,0,0,1-4.588-1.105,8.209,8.209,0,0,1-3.209-3.055,8.885,8.885,0,0,1,0-8.8,8.192,8.192,0,0,1,3.221-3.055,9.608,9.608,0,0,1,4.624-1.105,10.1,10.1,0,0,1,3.8.689,7.468,7.468,0,0,1,2.876,2.021l-1.949,1.9a6.254,6.254,0,0,0-4.588-1.9,6.485,6.485,0,0,0-3.126.737,5.373,5.373,0,0,0-2.139,2.068,5.949,5.949,0,0,0-.773,3.043,5.853,5.853,0,0,0,.773,3,5.533,5.533,0,0,0,2.139,2.092,6.269,6.269,0,0,0,3.1.761,6.7,6.7,0,0,0,3.423-.856Z",
    transform: "translate(-2576.744 -699.475)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3417",
    "data-name": "Group 3417",
    transform: "translate(18.21 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4827",
    "data-name": "Path 4827",
    d: "M2710.779,740.666a6.062,6.062,0,0,1-2.413-2.318,6.932,6.932,0,0,1,0-6.716,6.091,6.091,0,0,1,2.413-2.306,7.7,7.7,0,0,1,6.965,0,6.1,6.1,0,0,1,2.413,2.306,6.932,6.932,0,0,1,0,6.716,6.067,6.067,0,0,1-2.413,2.318,7.705,7.705,0,0,1-6.965,0Zm6.181-2.805a4.4,4.4,0,0,0,0-5.753,3.631,3.631,0,0,0-2.71-1.094,3.592,3.592,0,0,0-2.7,1.094,4.44,4.44,0,0,0,0,5.753,3.591,3.591,0,0,0,2.7,1.094A3.63,3.63,0,0,0,2716.96,737.861Z",
    transform: "translate(-2707.498 -728.494)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3418",
    "data-name": "Group 3418",
    transform: "translate(33.543 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4828",
    "data-name": "Path 4828",
    d: "M2820.879,740.666a6.063,6.063,0,0,1-2.413-2.318,6.93,6.93,0,0,1,0-6.716,6.092,6.092,0,0,1,2.413-2.306,7.7,7.7,0,0,1,6.966,0,6.1,6.1,0,0,1,2.413,2.306,6.932,6.932,0,0,1,0,6.716,6.068,6.068,0,0,1-2.413,2.318,7.706,7.706,0,0,1-6.966,0Zm6.181-2.805a4.4,4.4,0,0,0,0-5.753,3.631,3.631,0,0,0-2.71-1.094,3.592,3.592,0,0,0-2.7,1.094,4.44,4.44,0,0,0,0,5.753,3.591,3.591,0,0,0,2.7,1.094A3.63,3.63,0,0,0,2827.06,737.861Z",
    transform: "translate(-2817.598 -728.494)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3419",
    "data-name": "Group 3419",
    transform: "translate(48.877 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4829",
    "data-name": "Path 4829",
    d: "M2941.344,728.637v10.769q0,6.7-6.847,6.7a12.705,12.705,0,0,1-3.471-.464,7.365,7.365,0,0,1-2.71-1.343l1.331-2.235a6.365,6.365,0,0,0,2.1,1.106,8.256,8.256,0,0,0,2.579.416,4.259,4.259,0,0,0,3.067-.951,3.887,3.887,0,0,0,.975-2.9v-.666a4.887,4.887,0,0,1-1.854,1.26,6.537,6.537,0,0,1-2.4.428,6.886,6.886,0,0,1-3.269-.773,5.8,5.8,0,0,1-2.306-2.175,6.5,6.5,0,0,1,0-6.407,5.747,5.747,0,0,1,2.306-2.152,6.978,6.978,0,0,1,3.269-.761,6.706,6.706,0,0,1,2.508.452,4.632,4.632,0,0,1,1.89,1.379v-1.688Zm-4.006,8.594a3.43,3.43,0,0,0,1.082-2.627,3.365,3.365,0,0,0-1.082-2.591,4.373,4.373,0,0,0-5.563,0,3.363,3.363,0,0,0-1.082,2.591,3.427,3.427,0,0,0,1.082,2.627,4.333,4.333,0,0,0,5.563,0Z",
    transform: "translate(-2927.698 -728.494)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3420",
    "data-name": "Group 3420",
    transform: "translate(66.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4830",
    "data-name": "Path 4830",
    d: "M3053.672,694.012h2.972v17.64h-2.972Z",
    transform: "translate(-3053.672 -694.012)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3421",
    "data-name": "Group 3421",
    transform: "translate(72.245 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4831",
    "data-name": "Path 4831",
    d: "M3108.424,735.935h-9.961a3.451,3.451,0,0,0,1.367,2.223,4.481,4.481,0,0,0,2.746.82,4.627,4.627,0,0,0,3.447-1.379l1.593,1.831a5.365,5.365,0,0,1-2.163,1.545,8.574,8.574,0,0,1-6.633-.309,5.989,5.989,0,0,1-2.46-2.318,6.541,6.541,0,0,1-.868-3.364,6.644,6.644,0,0,1,.844-3.34,5.988,5.988,0,0,1,2.342-2.318,6.831,6.831,0,0,1,3.376-.832,6.661,6.661,0,0,1,3.316.82,5.811,5.811,0,0,1,2.282,2.306,6.993,6.993,0,0,1,.82,3.435Q3108.471,735.365,3108.424,735.935Zm-8.784-4.22a3.549,3.549,0,0,0-1.2,2.247h7.2a3.506,3.506,0,0,0-1.165-2.235,3.543,3.543,0,0,0-2.425-.856A3.585,3.585,0,0,0,3099.64,731.715Z",
    transform: "translate(-3095.491 -728.494)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3422",
    "data-name": "Group 3422",
    transform: "translate(94.924 0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4832",
    "data-name": "Path 4832",
    d: "M3268.952,701.9a5.479,5.479,0,0,1,2.46,2.044,6.246,6.246,0,0,1,0,6.312,5.45,5.45,0,0,1-2.46,2.056,9.215,9.215,0,0,1-3.768.713h-3.756v4.8h-3.09V701.182h6.846A9.215,9.215,0,0,1,3268.952,701.9Zm-.844,7.655a3.389,3.389,0,0,0,0-4.9,4.748,4.748,0,0,0-3.067-.856h-3.614v6.609h3.614A4.748,4.748,0,0,0,3268.107,709.55Z",
    transform: "translate(-3258.337 -701.182)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3423",
    "data-name": "Group 3423",
    transform: "translate(111.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4833",
    "data-name": "Path 4833",
    d: "M3380.216,694.012h2.972v17.64h-2.972Z",
    transform: "translate(-3380.216 -694.012)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3424",
    "data-name": "Group 3424",
    transform: "translate(117.865 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4834",
    "data-name": "Path 4834",
    d: "M3433.1,729.837a5.193,5.193,0,0,1,1.486,4.053v7.441h-2.805v-1.545a3.458,3.458,0,0,1-1.557,1.272,6.089,6.089,0,0,1-2.437.44,5.973,5.973,0,0,1-2.5-.487,3.852,3.852,0,0,1-1.652-1.355,3.437,3.437,0,0,1-.582-1.961,3.361,3.361,0,0,1,1.272-2.746,6.316,6.316,0,0,1,4.006-1.034h3.281v-.19a2.6,2.6,0,0,0-.8-2.044,3.445,3.445,0,0,0-2.365-.713,6.828,6.828,0,0,0-2.1.333,5.176,5.176,0,0,0-1.747.927l-1.165-2.163a7.219,7.219,0,0,1,2.4-1.165,10.687,10.687,0,0,1,2.972-.4A6.192,6.192,0,0,1,3433.1,729.837Zm-2.71,8.986a2.781,2.781,0,0,0,1.224-1.462v-1.474h-3.067q-2.568,0-2.567,1.688a1.514,1.514,0,0,0,.642,1.284,2.94,2.94,0,0,0,1.783.475A3.835,3.835,0,0,0,3430.394,738.823Z",
    transform: "translate(-3423.06 -728.494)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3425",
    "data-name": "Group 3425",
    transform: "translate(130.607 4.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4835",
    "data-name": "Path 4835",
    d: "M3528.8,729.518l-5.943,13.717a6.39,6.39,0,0,1-2.021,2.912,4.842,4.842,0,0,1-2.876.844,5.908,5.908,0,0,1-1.878-.309,4.154,4.154,0,0,1-1.522-.856l1.189-2.187a3.237,3.237,0,0,0,1.01.642,3.1,3.1,0,0,0,1.177.238,2.026,2.026,0,0,0,1.3-.4,3.579,3.579,0,0,0,.939-1.355l.214-.5-5.539-12.742h3.09l3.994,9.39,4.018-9.39Z",
    transform: "translate(-3514.555 -729.518)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3428",
    "data-name": "Group 3428",
    transform: "translate(56.721 10.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4836",
    "data-name": "Path 4836",
    d: "M2585.514,570.855a4.107,4.107,0,0,1-1.877-.439,4.964,4.964,0,0,1-1.517-1.179,5.576,5.576,0,0,1-1.007-1.668,5.262,5.262,0,0,1-.36-1.92,5.412,5.412,0,0,1,1.359-3.609,4.656,4.656,0,0,1,1.51-1.129,4.38,4.38,0,0,1,1.891-.41,4.45,4.45,0,0,1,2.445.618,3.978,3.978,0,0,1,1.452,1.611l-.992.69a2.992,2.992,0,0,0-1.222-1.323,3.465,3.465,0,0,0-1.711-.431,3,3,0,0,0-1.409.331,3.379,3.379,0,0,0-1.086.9,4.11,4.11,0,0,0-.69,1.287,4.735,4.735,0,0,0-.238,1.5,4.455,4.455,0,0,0,.266,1.546,3.982,3.982,0,0,0,.755,1.28,3.631,3.631,0,0,0,1.136.87,3.133,3.133,0,0,0,1.4.316,3.345,3.345,0,0,0,1.668-.446,5.051,5.051,0,0,0,1.5-1.366v1.338A4.152,4.152,0,0,1,2585.514,570.855Zm3.106-4.185h-2.2v-.978h3.293v5.091h-1.093Z",
    transform: "translate(-2580.754 -560.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4837",
    "data-name": "Path 4837",
    d: "M2666.161,570.077v1.151h-6.932v-10.21h6.8v1.151h-5.508v3.307h4.789v1.079h-4.789v3.523Z",
    transform: "translate(-2648.3 -560.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4838",
    "data-name": "Path 4838",
    d: "M2723.021,562.168H2719.5v9.06H2718.2v-9.06h-3.523v-1.151h8.341Z",
    transform: "translate(-2696.029 -560.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4839",
    "data-name": "Path 4839",
    d: "M2808.129,571.227v-10.21h1.294v10.21Z",
    transform: "translate(-2776.463 -560.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4840",
    "data-name": "Path 4840",
    d: "M2836.27,563.4v7.823h-1.294v-10.21h1.093l6.241,7.981v-7.967h1.294v10.2h-1.179Z",
    transform: "translate(-2799.57 -560.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4841",
    "data-name": "Path 4841",
    d: "M2940.661,570.855a4.37,4.37,0,0,1-1.956-.431,4.757,4.757,0,0,1-1.517-1.172,5.494,5.494,0,0,1-1.33-3.574,5.248,5.248,0,0,1,.367-1.949,5.434,5.434,0,0,1,1.021-1.654,4.934,4.934,0,0,1,1.532-1.151,4.335,4.335,0,0,1,1.912-.424,4.255,4.255,0,0,1,1.956.446,4.822,4.822,0,0,1,1.51,1.194,5.622,5.622,0,0,1,.978,1.668,5.373,5.373,0,0,1-1.028,5.486,4.842,4.842,0,0,1-1.531,1.143A4.4,4.4,0,0,1,2940.661,570.855Zm-3.494-5.177a4.553,4.553,0,0,0,.252,1.5,4.139,4.139,0,0,0,.712,1.287,3.443,3.443,0,0,0,1.107.892,3.112,3.112,0,0,0,1.438.331,3.066,3.066,0,0,0,1.467-.345,3.449,3.449,0,0,0,1.1-.92,4.193,4.193,0,0,0,.69-1.294,4.607,4.607,0,0,0,.237-1.452,4.5,4.5,0,0,0-.251-1.5,4.19,4.19,0,0,0-.719-1.287,3.426,3.426,0,0,0-1.107-.892,3.308,3.308,0,0,0-2.884.014,3.383,3.383,0,0,0-1.1.913,4.348,4.348,0,0,0-.7,1.287A4.456,4.456,0,0,0,2937.167,565.678Z",
    transform: "translate(-2886.403 -560.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    d: "M3019.138,563.4v7.823h-1.294v-10.21h1.093l6.241,7.981v-7.967h1.294v10.2h-1.179Z",
    transform: "translate(-2956.971 -560.945)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.88d20b608ba8719c304da08581b8c4c1.svg";
export { ForwardRef as ReactComponent };